// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .print-nav {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}
::ng-deep .print-intro {
  --family-7: "Museo-700";
  --family-3: "Museo-300";
  --family-1: "Museo-100";
  max-width: 1000px;
  margin: 30px auto;
  padding: 20px;
  width: 100%;
  font-family: var(--family-1);
}
::ng-deep .print-intro--cn {
  background-color: #e7e7e7;
  padding: 60px;
}
::ng-deep .print-intro--cn .print-footer {
  padding: 0;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro--cn {
    padding: 20px;
  }
}
::ng-deep .print-intro__inner {
  max-width: 600px;
  margin: 0px auto;
}
::ng-deep .print-intro__head {
  --gap: 35px;
  font-family: var(--family-1);
}
::ng-deep .print-intro__head .intro__pr img {
  max-width: 190px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro__pr img {
    max-width: 160px;
  }
}
::ng-deep .print-intro__head .intro__pr h3 {
  max-width: 596px !important;
  line-height: 1.1 !important;
  font-family: var(--family-1) !important;
  text-align: right;
  color: #979797;
}
::ng-deep .print-intro__head .intro__pr h3 strong {
  width: 100%;
  font-family: var(--family-7);
  color: #686b6d;
  margin-bottom: 5px;
  display: block;
}
::ng-deep .print-intro__head .intro__pr h3 sub {
  border: 0 !important;
}
::ng-deep .print-intro__head .intro-scan {
  display: flex;
  flex-direction: column;
}
::ng-deep .print-intro__head .intro-scan--flx {
  padding-bottom: var(--gap);
  display: flex;
  justify-content: space-between;
}
::ng-deep .print-intro__head .intro-scan__qr {
  height: 200px;
}
::ng-deep .print-intro__head .intro-scan h3 {
  font-size: 40px;
  max-width: 435px;
  line-height: 1.3;
  font-weight: 700;
  font-family: var(--family-7);
  margin-left: auto;
}
::ng-deep .print-intro__head .intro-scan h3 strong {
  font-size: 60px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro__head .intro-scan h3 strong {
    font-size: 44px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro-scan h3 strong {
    font-size: 24px;
  }
}
::ng-deep .print-intro__head .intro-scan h3 sup {
  font-size: 10px;
  border: 2px solid;
  border-radius: 50%;
  top: 15px;
  vertical-align: top;
  width: 15px;
  height: 15px;
  display: inline-block;
  text-align: center;
  padding: 6px 0;
}
::ng-deep .print-intro__head .intro-scan h3 sub {
  font-size: 12px;
  font-weight: normal;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro__head .intro-scan h3 {
    font-size: 24px;
    max-width: 486px !important;
  }
}
::ng-deep .print-intro__head .intro-content {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .print-intro__head .intro-content > div {
  width: 50%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro-content > div {
    width: 100%;
  }
}
::ng-deep .print-intro__head .intro-content__left {
  padding-right: 15px;
  font-size: 18px;
  color: #696c6e;
  max-width: 250px;
}
::ng-deep .print-intro__head .intro-content__left h4 {
  padding-bottom: 10px;
  font-size: 24px;
  font-family: var(--family-7);
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro__head .intro-content__left h4 {
    font-size: 20px;
  }
}
::ng-deep .print-intro__head .intro-content__left p {
  margin-top: 25px;
}
::ng-deep .print-intro__head .intro-content__left a {
  text-decoration: underline;
  color: #696c6e;
  display: block;
}
::ng-deep .print-intro__head .intro-content__left a.btn {
  color: #fff;
  text-decoration: none;
  font-family: var(--family-3);
  margin: 76px 0px 10px;
  padding: 13px 12px;
  border-radius: 0;
  width: 100%;
  font-size: 14px;
  text-align: center;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro-content__left a.btn {
    padding: 10px 20px;
    margin: 20px 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro-content__left {
    order: 2;
    padding-right: 0;
  }
}
::ng-deep .print-intro__head .intro-content__right img {
  margin-top: -35px;
  margin-left: -22px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro__head .intro-content__right img {
    margin-top: 0;
    margin-left: 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .print-intro__head .intro-content__right {
    margin-bottom: 20px;
  }
}
::ng-deep .print-intro__head .intro-content--bottom {
  display: block;
}
::ng-deep .print-intro__head .intro-content--bottom a {
  display: block;
  text-decoration: underline;
  color: #696c6e;
}
::ng-deep .print-intro__head .intro-content--bottom span {
  margin-right: 10px;
}
::ng-deep .print-intro__head .intro-content--bottom .launch {
  display: inline-block;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .print-intro__head .intro-content--top {
    margin-top: 30px;
  }
}
::ng-deep .print-intro__head .intro-frame h3 {
  max-width: none;
}
::ng-deep .print-intro__head .intro-frame p {
  font-size: 20px;
}
::ng-deep .print-intro__head .intro-frame--img {
  padding-bottom: calc(var(--gap) + 20px);
}
::ng-deep .print-intro__head .intro-frame--img img {
  padding-block: var(--gap);
  width: 80%;
  margin: 0 auto;
  display: block;
}
::ng-deep .print-intro__head .intro-frame--img p {
  font-size: 40px;
  font-weight: 300;
}
::ng-deep .print-intro__head .intro-frame--img p:last-child {
  font-size: 16px;
  font-weight: bold;
  text-align: right;
  width: 86%;
  font-family: var(--family-7);
}
::ng-deep .print-intro__head .intro-form {
  padding-bottom: calc(var(--gap) + 15px);
}
::ng-deep .print-intro__head .intro-form form input {
  width: 100%;
  border: 0;
  margin-bottom: 4px;
  background-color: #e7e7e7;
}
::ng-deep .print-intro__head .intro-form form input::placeholder {
  font-family: var(--family-7);
}
::ng-deep .print-intro__head .intro-form form input:focus {
  outline: none;
}
::ng-deep .print-intro__head .intro-bt {
  padding-bottom: calc(var(--gap) / 2);
}
::ng-deep .print-intro__head .intro-bt h3 {
  font-size: 26px;
  font-family: var(--family-7);
  margin-bottom: 0;
}
::ng-deep .print-intro__head .intro-bt p {
  width: 50%;
  font-family: var(--family-3);
  font-size: 17px;
}
::ng-deep .print-intro__head .intro-pf {
  padding-bottom: calc(var(--gap) / 2);
}
::ng-deep .print-intro__head .intro-pf p {
  margin: 0;
  font-family: var(--family-3);
  font-size: 17px;
}
::ng-deep .print-intro__head .intro-pf p b {
  font-family: var(--family-7);
}
::ng-deep .print-intro__head .intro-dir {
  padding-bottom: var(--gap);
}
::ng-deep .print-intro__head .intro-dir h3 {
  font-family: var(--family-7);
  font-size: 17px;
}
::ng-deep .print-intro__head .intro-dir ol {
  padding: 0 0 0 20px;
  list-style-type: disc;
}
::ng-deep .print-intro__head .intro-dir ol li {
  padding-bottom: 2px;
  font-family: var(--family-3);
  font-size: 17px;
}
::ng-deep .print-footer {
  width: 100%;
  padding-bottom: 70px;
}
::ng-deep .print-footer--spc {
  padding-left: var(--spc);
}
::ng-deep .print-footer--spc p {
  letter-spacing: 0.2px;
}
::ng-deep .print-footer--spc p:first-child {
  margin: 0;
}
::ng-deep .print-footer--spc p:last-child {
  font-size: 13px;
}
::ng-deep .print-footer__flx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::ng-deep .print-footer__flx img {
  width: 25%;
}

::ng-deep .cn-print {
  --spc: 50px;
  --family-7: "Museo-700";
  --family-3: "Museo-300";
  --family-1: "Museo-100";
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  font-family: var(--family-1);
}
::ng-deep .cn-print-smple {
  display: block;
  margin: 0;
  position: absolute !important;
  font-size: 8px;
  background: red;
  color: #fff;
  border-radius: 3px;
  left: 50%;
  padding-inline: 5px;
  font-weight: bold;
  opacity: 0.6;
}
::ng-deep .cn-print-ss {
  left: 50%;
  transform: translateX(-50%);
}
::ng-deep .cn-print h3 {
  font-family: var(--family-7);
}
::ng-deep .cn-print__head--mh {
  min-height: 600px;
}
::ng-deep .cn-print__head .cn-hdr {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: #fff;
  border-radius: 5px 5px 0 0;
  padding: 20px var(--spc);
  flex-wrap: wrap;
}
::ng-deep .cn-print__head .cn-hdr-summary > h3 {
  color: #6D6E71 !important;
  font-size: 50px !important;
}
::ng-deep .cn-print__head .cn-hdr-summary > h3 svg {
  padding-top: 17px;
  margin-left: -11px;
}
::ng-deep .cn-print__head .cn-hdr--clarify {
  background-color: #00AFDA;
}
::ng-deep .cn-print__head .cn-hdr--ideate {
  background-color: #F58A1F;
}
::ng-deep .cn-print__head .cn-hdr--implement {
  background-color: #EE455A;
}
::ng-deep .cn-print__head .cn-hdr--develop {
  background-color: #68BC49;
}
::ng-deep .cn-print__head .cn-hdr > h3 {
  font-size: 30px;
  color: #fff;
  margin-block: 0;
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  ::ng-deep .cn-print__head .cn-hdr > h3 {
    width: 100%;
  }
}
::ng-deep .cn-print__head .cn-hdr p {
  font-weight: 600;
  font-family: "Museo-700";
  font-size: 22px;
  margin-block: 0;
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  ::ng-deep .cn-print__head .cn-hdr p {
    width: 100%;
  }
}
::ng-deep .cn-print__info {
  display: flex;
  padding-inline: 50px;
  justify-content: space-between;
}
::ng-deep .cn-print__info p {
  font-family: "Museo-700";
}
::ng-deep .cn-print__body {
  --bdr-size: 1px;
}
::ng-deep .cn-print__body .cn-item {
  padding: 10px var(--spc);
}
::ng-deep .cn-print__body .cn-item:last-child {
  padding-bottom: calc(var(--spc) + 20px);
}
::ng-deep .cn-print__body .cn-item p {
  font-size: 17px;
}
::ng-deep .cn-print__body .cn-item__txt:not(:first-child) {
  margin-top: 10px;
}
::ng-deep .cn-print__body .cn-item__txt--cl i {
  color: rgb(0, 173, 208);
}
::ng-deep .cn-print__body .cn-item__txt p:last-child {
  margin-bottom: 0;
}
::ng-deep .cn-print__body .cn-item--cl {
  background-color: #E2F3F9;
  padding-bottom: 20px;
}
::ng-deep .cn-print__body .cn-item--id {
  background-color: #FFEFE1;
  padding-bottom: 20px;
}
::ng-deep .cn-print__body .cn-item--dev {
  background-color: #ECF5E8;
  padding-bottom: 20px;
}
::ng-deep .cn-print__body .cn-item--imple {
  background-color: #FDE9E5;
  padding-bottom: 20px;
}
::ng-deep .cn-print__body .cn-item__top ul li .inp-des--txtstyl {
  font-family: "Marydale";
  color: #676a6c;
}
::ng-deep .cn-print__body .cn-item__top h3 {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}
::ng-deep .cn-print__body .cn-item__top h3 i {
  cursor: pointer;
}
::ng-deep .cn-print__body .cn-item__top--cl h3 {
  font-size: 20px;
  color: rgb(0, 173, 208);
}
::ng-deep .cn-print__body .cn-item__top--id h3 {
  font-size: 20px;
  color: rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__top--id i {
  color: rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__top--dev h3 {
  font-size: 20px;
  color: rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__top--dev span {
  font-family: var(--family-7);
  color: rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__top--imple h3 {
  font-size: 20px;
  color: rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__top--potential h3 {
  font-size: 20px;
  color: #6D6E71;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des {
  border: var(--bdr-size) solid rgb(0, 173, 208);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des--txtstyl {
  font-family: "Marydale";
  color: #676a6c;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id {
  border: var(--bdr-size) solid rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular {
  counter-reset: section;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular-flx {
  display: flex;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular-flx > div ol {
  display: block;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular-flx > div ol li {
  width: 100%;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular-flx > div ol li:nth-of-type(2n) {
  border-left: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular-flx > div ol li:nth-last-of-type(2) {
  border-bottom: var(--bdr-size) dashed rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular ol {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular ol li {
  color: rgb(255, 121, 0);
  width: 50%;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular ol li::before {
  counter-increment: section;
  content: "" counter(section) ". ";
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular ol li:nth-of-type(2n) {
  border-left: var(--bdr-size) solid rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular ol li:nth-last-of-type(2) {
  border-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular > div {
  width: 50%;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-id .tabular > div:first-child {
  border-right: var(--bdr-size) solid rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev {
  border: var(--bdr-size) solid rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table {
  color: rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table th,
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table td {
  border-bottom: 1px dashed rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table th.bb-0,
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table td.bb-0 {
  border-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tr:last-child th,
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tr:last-child td {
  border-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th {
  border-right: 1px solid rgb(105, 190, 40);
  width: 290px;
  padding: 8px 10px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th:last-child {
  border-right: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th span {
  height: 25px;
  width: 25px;
  background: rgb(105, 190, 40);
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 11px;
  color: #fff;
  padding: 5px 8px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th p {
  font-size: 12px;
  font-weight: 400;
  flex: 1;
  padding-left: 10px;
  margin-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th p strong {
  font-family: var(--family-7);
  font-size: 14px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table thead tr th .ev-th {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td {
  border-right: 1px solid rgb(105, 190, 40);
  padding: 8px 10px;
  vertical-align: text-top;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td.opp {
  font-weight: 700;
  border-top: var(--bdr-size) solid rgb(105, 190, 40);
  border-bottom: var(--bdr-size) solid rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td.opp span {
  height: 25px;
  width: 25px;
  background: rgb(105, 190, 40);
  display: inline-block;
  border-radius: 50%;
  text-align: center;
  font-size: 11px;
  color: #fff;
  padding: 5px 8px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td.opp .ev-td {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td.opp .ev-td p {
  font-size: 12px;
  font-weight: 400;
  flex: 1;
  padding-left: 10px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td.opp .ev-td p strong {
  font-family: var(--family-7);
  font-size: 14px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-dev table tbody tr td:last-child {
  border-right: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple {
  border: var(--bdr-size) solid rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table {
  width: 100%;
  color: rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr.imple-clr {
  background-color: rgb(245, 67, 89);
  color: #fff;
  font-weight: 700;
  font-size: 12px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr.imple-clr td:not(:last-child) {
  border-right: 1px dashed #fff;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr th {
  padding: 8px 10px;
  border-right: 1px dashed rgb(245, 67, 89);
  font-family: var(--family-1);
  font-weight: normal;
  text-transform: uppercase;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr th.dark-th {
  color: #6d6e71;
  font-family: var(--family-1);
  padding-left: 0;
  font-weight: normal;
  text-transform: none;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr th:first-child {
  width: 72%;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr th:last-child {
  border-right: none;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr td {
  border-right: 1px dashed rgb(245, 67, 89);
  border-bottom: 1px dashed rgb(245, 67, 89);
  padding: 8px 10px;
  font-size: 13px;
  letter-spacing: 1px;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr td:first-child {
  width: 72%;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr td:last-child {
  border-right: none;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-imple table tr:last-child td {
  border-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary {
  border: none;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary thead tr {
  border-inline: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary thead tr th {
  border: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary tbody tr {
  border-inline: var(--bdr-size) solid rgb(245, 67, 89);
  border-bottom: var(--bdr-size) solid rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary tbody tr:first-child {
  border-top: var(--bdr-size) solid rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-summary tbody tr:not(:last-child) {
  border-bottom: var(--bdr-size) dashed rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des-potential {
  border: var(--bdr-size) solid #6D6E71;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li {
  border-bottom: var(--bdr-size) dashed rgb(0, 173, 208);
  min-height: 32px;
  background-color: #fff;
  min-height: 32px;
  padding: 8px 10px;
  margin: 0;
  color: rgb(0, 173, 208);
  font-family: var(--family-7);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li.id {
  border-bottom: var(--bdr-size) dashed rgb(255, 121, 0);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li.dev {
  border-bottom: var(--bdr-size) dashed rgb(105, 190, 40);
  color: rgb(105, 190, 40);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li.imple {
  border-bottom: var(--bdr-size) dashed rgb(245, 67, 89);
  color: rgb(245, 67, 89);
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li.potential {
  border-bottom: var(--bdr-size) dashed #6D6E71;
  color: #6D6E71;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des ol li:last-child {
  border-bottom: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des__data {
  min-height: 220px;
  border: 0;
}
::ng-deep .cn-print__body .cn-item__inp .inp-des__data .inp-des--txtstyl {
  padding-left: 40px;
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  ::ng-deep .cn-print-nav ul li {
    margin: 0 !important;
    width: 100%;
  }
}
@media (min-width: 769px) and (max-width: 991px), (max-width: 640px) {
  ::ng-deep .cn-print-nav ul {
    gap: 6px;
  }
}

.page-heading {
  display: flex;
}
.page-heading__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -10px;
  width: 100%;
}
.page-heading__inner a {
  font-family: "Open Sans", sans-serif;
}
.page-heading__inner .page-heading__col {
  padding: 0 10px;
}
.page-heading__inner .page-heading__col--pd {
  padding: 0 25px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col--left {
    width: 100%;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right {
  margin-left: auto;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right {
    width: 100%;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul {
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li {
  list-style: none;
  position: relative;
  margin-top: 7px;
  margin-bottom: 7px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li {
    margin-top: 0;
    margin-bottom: 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li:not(:last-child) {
  margin-right: 15px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li:not(:last-child) {
    margin-right: 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
  font-size: 16px;
  color: #676a6a;
  font-weight: 700;
  background-color: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a {
    font-size: 13px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
  padding: 11px 14px;
  border-right: 1px solid #ededed;
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
    padding: 10px 12px;
  }
}
@media only screen and (max-width: 991px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__icon {
    padding: 9px 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
  padding: 11px 14px;
}
@media only screen and (max-width: 1200px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
    padding: 10px 12px;
  }
}
@media only screen and (max-width: 991px) {
  .page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a .page-heading__text {
    padding: 9px 10px;
  }
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li > a:hover {
  border: 1px solid #CFDBE2;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li:hover > ul {
  display: block;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul {
  margin: 0;
  padding: 0;
  display: none;
  position: absolute;
  top: calc(100% - 1px);
  right: 0;
  width: 144px;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  background-color: #fff;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li {
  list-style: none;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li + li {
  border-top: 1px solid #dcdcdc;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li a {
  color: #696969;
  text-align: center;
  padding: 8px 20px;
  font-size: 13px;
  display: block;
  transition: all ease 0.3s;
}
.page-heading__inner .page-heading__col.page-heading__col--right > ul > li ul li a:hover {
  background-color: #f9f9f9;
}

::ng-deep footer .footer {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/cn-print/cn-print.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAvYE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AA0YJ;AAvYE;EACE,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;AAyYJ;AAvYI;EACE,yBAAA;EACA,aAAA;AAyYN;AAvYM;EACE,UAAA;AAyYR;AAtYM;EARF;IASI,aAAA;EAyYN;AACF;AAtYI;EACE,gBAAA;EACA,gBAAA;AAwYN;AAnYI;EACE,WAAA;EACA,4BAAA;AAqYN;AA/XU;EACE,gBAAA;AAiYZ;AA/XY;EAHF;IAII,gBAAA;EAkYZ;AACF;AA/XU;EACE,2BAAA;EACA,2BAAA;EACA,uCAAA;EACA,iBAAA;EACA,cAAA;AAiYZ;AA/XY;EACE,WAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;AAiYd;AA9XY;EACE,oBAAA;AAgYd;AA3XQ;EACE,aAAA;EACA,sBAAA;AA6XV;AA3XU;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AA6XZ;AA1XU;EACE,aAAA;AA4XZ;AAzXU;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,iBAAA;AA2XZ;AAzXY;EACE,eAAA;AA2Xd;AAzXc;EAHF;IAII,eAAA;EA4Xd;AACF;AA1Xc;EAPF;IAQI,eAAA;EA6Xd;AACF;AA1XY;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AA4Xd;AAzXY;EACE,eAAA;EAQA,mBAAA;AAoXd;AAjXY;EA7CF;IA8CI,eAAA;IACA,2BAAA;EAoXZ;AACF;AA/WQ;EACE,aAAA;EACA,eAAA;AAiXV;AA/WU;EACE,UAAA;AAiXZ;AA/WY;EAHF;IAII,WAAA;EAkXZ;AACF;AA/WU;EACE,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAiXZ;AA/WY;EACE,oBAAA;EACA,eAAA;EACA,4BAAA;AAiXd;AA/Wc;EALF;IAMI,eAAA;EAkXd;AACF;AA/WY;EACE,gBAAA;AAiXd;AA9WY;EACE,0BAAA;EACA,cAAA;EACA,cAAA;AAgXd;AA7WY;EACE,WAAA;EACA,qBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA+Wd;AA7Wc;EAXF;IAYI,kBAAA;IACA,cAAA;EAgXd;AACF;AA7WY;EA3CF;IA4CI,QAAA;IACA,gBAAA;EAgXZ;AACF;AA5WY;EACE,iBAAA;EACA,kBAAA;AA8Wd;AA5Wc;EAJF;IAKI,aAAA;IACA,cAAA;EA+Wd;AACF;AA5WY;EAXF;IAYI,mBAAA;EA+WZ;AACF;AA5WU;EAEE,cAAA;AA6WZ;AA3WY;EACE,cAAA;EACA,0BAAA;EACA,cAAA;AA6Wd;AA1WY;EACE,kBAAA;AA4Wd;AAzWY;EACE,qBAAA;AA2Wd;AAtWY;EADF;IAEI,gBAAA;EAyWZ;AACF;AApWU;EACE,eAAA;AAsWZ;AAnWU;EACE,eAAA;AAqWZ;AAlWU;EACE,uCAAA;AAoWZ;AAlWY;EACE,yBAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;AAoWd;AAjWY;EACE,eAAA;EACA,gBAAA;AAmWd;AAjWc;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,4BAAA;AAmWhB;AA7VQ;EACE,uCAAA;AA+VV;AA3VY;EACE,WAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AA6Vd;AA3Vc;EACE,4BAAA;AA6VhB;AA1Vc;EACE,aAAA;AA4VhB;AAtVQ;EACE,oCAAA;AAwVV;AAtVU;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;AAwVZ;AArVU;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AAuVZ;AAnVQ;EACE,oCAAA;AAqVV;AAnVU;EACE,SAAA;EACA,4BAAA;EACA,eAAA;AAqVZ;AAnVY;EACE,4BAAA;AAqVd;AAhVQ;EACE,0BAAA;AAkVV;AAhVU;EACE,4BAAA;EACA,eAAA;AAkVZ;AA/UU;EACE,mBAAA;EACA,qBAAA;AAiVZ;AA/UY;EACE,mBAAA;EACA,4BAAA;EACA,eAAA;AAiVd;AAtUE;EACE,WAAA;EACA,oBAAA;AAwUJ;AAtUI;EACE,wBAAA;AAwUN;AAtUM;EACE,qBAAA;AAwUR;AAtUQ;EACE,SAAA;AAwUV;AArUQ;EACE,eAAA;AAuUV;AAlUI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAoUN;AAlUM;EACE,UAAA;AAoUR;;AA9TA;EACE,WAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;AAiUF;AA/TE;EACE,cAAA;EACA,SAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAiUJ;AA9TE;EACE,SAAA;EACA,2BAAA;AAgUJ;AA7TE;EACE,4BAAA;AA+TJ;AA1TI;EACE,iBAAA;AA4TN;AAzTI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;EACA,0BAAA;EACA,wBAAA;EACA,eAAA;AA2TN;AAvTQ;EACE,yBAAA;EACA,0BAAA;AAyTV;AAvTU;EACE,iBAAA;EACA,kBAAA;AAyTZ;AApTM;EACE,yBAAA;AAsTR;AAnTM;EACE,yBAAA;AAqTR;AAlTM;EACE,yBAAA;AAoTR;AAjTM;EACE,yBAAA;AAmTR;AAhTM;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAkTR;AAhTQ;EALF;IAOI,WAAA;EAkTR;AACF;AA/SM;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;AAiTR;AA/SQ;EANF;IAQI,WAAA;EAiTR;AACF;AA5SE;EACE,aAAA;EACA,oBAAA;EACA,8BAAA;AA8SJ;AA5SI;EACE,wBAAA;AA8SN;AA1SE;EACE,eAAA;AA4SJ;AA1SI;EACE,wBAAA;AA4SN;AA1SM;EACE,uCAAA;AA4SR;AAzSM;EACE,eAAA;AA2SR;AArSQ;EACE,gBAAA;AAuSV;AAnSU;EACE,uBD9fI;ACmyBhB;AAjSQ;EACE,gBAAA;AAmSV;AA/RM;EACE,yBAAA;EACA,oBAAA;AAiSR;AA9RM;EACE,yBAAA;EACA,oBAAA;AAgSR;AA7RM;EACE,yBAAA;EACA,oBAAA;AA+RR;AA5RM;EACE,yBAAA;EACA,oBAAA;AA8RR;AAvRY;EACE,uBD7iBH;EC8iBG,cDnhBO;AC4yBrB;AApRQ;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;AAsRV;AApRU;EACE,eAAA;AAsRZ;AAhRU;EACE,eAAA;EACA,uBDrjBI;ACu0BhB;AA7QU;EACE,eAAA;EACA,uBD3jBG;AC00Bf;AA5QU;EACE,uBD/jBG;AC60Bf;AAzQU;EACE,eAAA;EACA,wBDrkBI;ACg1BhB;AAxQU;EACE,4BAAA;EACA,wBD1kBI;ACo1BhB;AArQU;EACE,eAAA;EACA,uBDhlBM;ACu1BlB;AAlQU;EACE,eAAA;EACA,cAAA;AAoQZ;AA1PU;EACE,8CAAA;AA4PZ;AA1PY;EACE,uBDrnBH;ECsnBG,cD3lBO;ACu1BrB;AAzPY;EACE,8CAAA;AA2Pd;AAzPc;EACE,sBAAA;AA2PhB;AAzPgB;EACE,aAAA;AA2PlB;AAvPoB;EACE,cAAA;AAyPtB;AAvPsB;EACE,WAAA;AAyPxB;AAvPwB;EACE,cAAA;AAyP1B;AAtPwB;EACE,sDAAA;AAwP1B;AAxOgB;EACE,gBAAA;EACA,aAAA;EACA,eAAA;AA0OlB;AAxOkB;EACE,uBDvpBL;ECwpBK,UAAA;AA0OpB;AAxOoB;EACE,0BAAA;EACA,iCAAA;AA0OtB;AAvOoB;EACE,mDAAA;AAyOtB;AAtOoB;EACE,gBAAA;AAwOtB;AAnOgB;EACE,UAAA;AAqOlB;AAnOkB;EACE,oDAAA;AAqOpB;AA9NY;EACE,+CAAA;AAgOd;AA9Nc;EACE,wBDvrBA;ACu5BhB;AA9NgB;;EAEE,2CAAA;AAgOlB;AA9NkB;;EACE,gBAAA;AAiOpB;AA1NkB;;EAEE,gBAAA;AA4NpB;AAnNoB;EACE,yCAAA;EACA,YAAA;EACA,iBAAA;AAqNtB;AAnNsB;EACE,eAAA;AAqNxB;AAlNsB;EACE,YAAA;EACA,WAAA;EACA,6BD5tBR;EC6tBQ,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAoNxB;AAjNsB;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;AAmNxB;AAjNwB;EACE,4BAAA;EACA,eAAA;AAmN1B;AA/MsB;EACE,aAAA;EACA,eAAA;AAiNxB;AAvMoB;EACE,yCAAA;EACA,iBAAA;EACA,wBAAA;AAyMtB;AAvMsB;EACE,gBAAA;EACA,mDAAA;EACA,sDAAA;AAyMxB;AAvMwB;EACE,YAAA;EACA,WAAA;EACA,6BD3wBV;EC4wBU,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAyM1B;AAtMwB;EACE,aAAA;EACA,eAAA;AAwM1B;AAtM0B;EACE,eAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;AAwM5B;AAtM4B;EACE,4BAAA;EACA,eAAA;AAwM9B;AAhMsB;EACE,eAAA;AAkMxB;AA1LY;EACE,8CAAA;AA4Ld;AA1Lc;EACE,WAAA;EACA,uBDrzBE;ACi/BlB;AAxLkB;EACE,kCD1zBF;EC2zBE,WAAA;EACA,gBAAA;EACA,eAAA;AA0LpB;AAtLsB;EACE,6BAAA;AAwLxB;AAnLkB;EACE,iBAAA;EACA,yCAAA;EACA,4BAAA;EACA,mBAAA;EACA,yBAAA;AAqLpB;AAnLoB;EACE,cD/zBD;ECg0BC,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;AAqLtB;AAlLoB;EACE,UAAA;AAoLtB;AAjLoB;EACE,kBAAA;AAmLtB;AA/KkB;EACE,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAiLpB;AA/KoB;EACE,UAAA;AAiLtB;AA9KoB;EACE,kBAAA;AAgLtB;AA1KoB;EACE,gBAAA;AA4KtB;AArKY;EACE,YAAA;AAuKd;AAnKgB;EACE,gBAAA;AAqKlB;AAnKkB;EACE,SAAA;AAqKpB;AA/JgB;EACE,qDAAA;EACA,qDAAA;AAiKlB;AA/JkB;EACE,kDAAA;AAiKpB;AA9JkB;EACE,sDAAA;AAgKpB;AAxJY;EACE,qCAAA;AA0Jd;AAvJY;EACE,qBAAA;EACA,UAAA;EACA,SAAA;AAyJd;AAvJc;EACE,sDAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,uBD56BA;EC66BA,4BAAA;AAyJhB;AAtJgB;EACE,sDAAA;AAwJlB;AApJgB;EACE,uDAAA;EACA,wBDr7BF;AC2kChB;AAnJgB;EACE,sDAAA;EACA,uBDz7BA;AC8kClB;AAlJgB;EACE,6CAAA;EACA,cAAA;AAoJlB;AAjJgB;EACE,gBAAA;AAmJlB;AA7IY;EACE,iBAAA;EACA,SAAA;AA+Id;AA7Ic;EACE,kBAAA;AA+IhB;AA/HQ;EAFF;IAKI,oBAAA;IACA,WAAA;EAgIR;AACF;AA7HM;EAZF;IAcI,QAAA;EA+HN;AACF;;AAxHA;EACE,aAAA;AA2HF;AAzHE;EAGE,aAAA;EAEA,eAAA;EAGA,mBAAA;EACA,eAAA;EACA,WAAA;AA2HJ;AAzHI;EACE,oCAAA;AA2HN;AAxHI;EACE,eAAA;AA0HN;AAxHM;EACE,eAAA;AA0HR;AArHQ;EAFF;IAGI,WAAA;EAwHR;AACF;AArHM;EACE,iBAAA;AAuHR;AArHQ;EAHF;IAII,WAAA;EAwHR;AACF;AAtHQ;EACE,UAAA;EACA,SAAA;EAGA,aAAA;EAEA,eAAA;AAwHV;AAtHU;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAwHZ;AAtHY;EANF;IAOI,aAAA;IACA,mBAAA;EAyHZ;AACF;AAvHY;EACE,kBAAA;AAyHd;AAvHc;EAHF;IAII,kBAAA;EA0Hd;AACF;AAvHY;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAEA,eAAA;EAGA,yBAAA;AAyHd;AAvHc;EAjBF;IAkBI,eAAA;EA0Hd;AACF;AAxHc;EArBF;IAsBI,eAAA;EA2Hd;AACF;AAzHc;EACE,kBAAA;EACA,+BAAA;EAGA,aAAA;EAGA,mBAAA;AA2HhB;AAzHgB;EAVF;IAWI,kBAAA;EA4HhB;AACF;AA1HgB;EAdF;IAeI,iBAAA;EA6HhB;AACF;AAzHc;EACE,kBAAA;AA2HhB;AAzHgB;EAHF;IAII,kBAAA;EA4HhB;AACF;AA1HgB;EAPF;IAQI,iBAAA;EA6HhB;AACF;AA1Hc;EACE,yBAAA;AA4HhB;AAxHY;EACE,cAAA;AA0Hd;AAvHY;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAyHd;AAvHc;EACE,gBAAA;AAyHhB;AAvHgB;EACE,6BAAA;AAyHlB;AAtHgB;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EAGA,yBAAA;AAwHlB;AAtHkB;EACE,yBAAA;AAwHpB;;AA3GE;EACE,kBAAA;AA8GJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n\n::ng-deep .print {\n\n  &-nav {\n    max-width: 1000px;\n    margin: 0 auto;\n    padding: 0 20px;\n    width: 100%;\n  }\n\n  &-intro {\n    --family-7: \"Museo-700\";\n    --family-3: \"Museo-300\";\n    --family-1: \"Museo-100\";\n    max-width: 1000px;\n    margin: 30px auto;\n    padding: 20px;\n    width: 100%;\n    font-family: var(--family-1);\n\n    &--cn {\n      background-color: #e7e7e7;\n      padding: 60px;\n\n      .print-footer {\n        padding: 0;\n      }\n\n      @media #{$tablet} {\n        padding: 20px;\n      }\n    }\n\n    &__inner {\n      max-width: 600px;\n      margin: 0px auto;\n\n\n    }\n\n    &__head {\n      --gap: 35px;\n      font-family: var(--family-1);\n\n      .intro {\n\n        &__pr {\n\n          img {\n            max-width: 190px;\n\n            @media #{$mobile} {\n              max-width: 160px;\n            }\n          }\n\n          h3 {\n            max-width: 596px !important;\n            line-height: 1.1 !important;\n            font-family: var(--family-1) !important;\n            text-align: right;\n            color: #979797;\n\n            strong {\n              width: 100%;\n              font-family: var(--family-7);\n              color: #686b6d;\n              margin-bottom: 5px;\n              display: block;\n            }\n\n            sub {\n              border: 0 !important;\n            }\n          }\n        }\n\n        &-scan {\n          display: flex;\n          flex-direction: column;\n\n          &--flx {\n            padding-bottom: var(--gap);\n            display: flex;\n            justify-content: space-between;\n          }\n\n          &__qr {\n            height: 200px;\n          }\n\n          h3 {\n            font-size: 40px;\n            max-width: 435px;\n            line-height: 1.3;\n            font-weight: 700;\n            font-family: var(--family-7);\n            margin-left: auto;\n\n            strong {\n              font-size: 60px;\n\n              @media #{$tablet} {\n                font-size: 44px;\n              }\n\n              @media #{$mobile} {\n                font-size: 24px;\n              }\n            }\n\n            sup {\n              font-size: 10px;\n              border: 2px solid;\n              border-radius: 50%;\n              top: 15px;\n              vertical-align: top;\n              width: 15px;\n              height: 15px;\n              display: inline-block;\n              text-align: center;\n              padding: 6px 0;\n            }\n\n            sub {\n              font-size: 12px;\n              // height: 15px;\n              // width: 15px;\n              // border: 1px solid;\n              // border-radius: 50%;\n              // display: inline-block;\n              // text-align: center;\n              // padding: 6px 3px;\n              font-weight: normal;\n            }\n\n            @media #{$tablet} {\n              font-size: 24px;\n              max-width: 486px !important;\n            }\n\n          }\n        }\n\n        &-content {\n          display: flex;\n          flex-wrap: wrap;\n\n          &>div {\n            width: 50%;\n\n            @media #{$mobile} {\n              width: 100%;\n            }\n          }\n\n          &__left {\n            padding-right: 15px;\n            font-size: 18px;\n            color: #696c6e;\n            max-width: 250px;\n\n            h4 {\n              padding-bottom: 10px;\n              font-size: 24px;\n              font-family: var(--family-7);\n\n              @media #{$tablet} {\n                font-size: 20px;\n              }\n            }\n\n            p {\n              margin-top: 25px;\n            }\n\n            a {\n              text-decoration: underline;\n              color: #696c6e;\n              display: block;\n            }\n\n            a.btn {\n              color: #fff;\n              text-decoration: none;\n              font-family: var(--family-3);\n              margin: 76px 0px 10px;\n              padding: 13px 12px;\n              border-radius: 0;\n              width: 100%;\n              font-size: 14px;\n              text-align: center;\n\n              @media #{$mobile} {\n                padding: 10px 20px;\n                margin: 20px 0;\n              }\n            }\n\n            @media #{$mobile} {\n              order: 2;\n              padding-right: 0;\n            }\n          }\n\n          &__right {\n            img {\n              margin-top: -35px;\n              margin-left: -22px;\n\n              @media #{$tablet} {\n                margin-top: 0;\n                margin-left: 0;\n              }\n            }\n\n            @media #{$mobile} {\n              margin-bottom: 20px;\n            }\n          }\n\n          &--bottom {\n\n            display: block;\n\n            a {\n              display: block;\n              text-decoration: underline;\n              color: #696c6e;\n            }\n\n            span {\n              margin-right: 10px;\n            }\n\n            .launch {\n              display: inline-block;\n            }\n          }\n\n          &--top {\n            @media #{$tablet} {\n              margin-top: 30px;\n            }\n          }\n        }\n\n        &-frame {\n          h3 {\n            max-width: none;\n          }\n\n          p {\n            font-size: 20px;\n          }\n\n          &--img {\n            padding-bottom: calc(var(--gap) + 20px);\n\n            img {\n              padding-block: var(--gap);\n              width: 80%;\n              margin: 0 auto;\n              display: block;\n            }\n\n            p {\n              font-size: 40px;\n              font-weight: 300;\n\n              &:last-child {\n                font-size: 16px;\n                font-weight: bold;\n                text-align: right;\n                width: 86%;\n                font-family: var(--family-7);\n              }\n            }\n          }\n        }\n\n        &-form {\n          padding-bottom: calc(var(--gap) + 15px);\n\n          form {\n\n            input {\n              width: 100%;\n              border: 0;\n              margin-bottom: 4px;\n              background-color: #e7e7e7;\n\n              &::placeholder {\n                font-family: var(--family-7);\n              }\n\n              &:focus {\n                outline: none;\n              }\n            }\n          }\n        }\n\n        &-bt {\n          padding-bottom: calc(var(--gap) / 2);\n\n          h3 {\n            font-size: 26px;\n            font-family: var(--family-7);\n            margin-bottom: 0;\n          }\n\n          p {\n            width: 50%;\n            font-family: var(--family-3);\n            font-size: 17px;\n          }\n        }\n\n        &-pf {\n          padding-bottom: calc(var(--gap) / 2);\n\n          p {\n            margin: 0;\n            font-family: var(--family-3);\n            font-size: 17px;\n\n            b {\n              font-family: var(--family-7);\n            }\n          }\n        }\n\n        &-dir {\n          padding-bottom: var(--gap);\n\n          h3 {\n            font-family: var(--family-7);\n            font-size: 17px;\n          }\n\n          ol {\n            padding: 0 0 0 20px;\n            list-style-type: disc;\n\n            li {\n              padding-bottom: 2px;\n              font-family: var(--family-3);\n              font-size: 17px;\n            }\n          }\n        }\n\n      }\n\n    }\n\n  }\n\n  &-footer {\n    width: 100%;\n    padding-bottom: 70px;\n\n    &--spc {\n      padding-left: var(--spc);\n\n      p {\n        letter-spacing: 0.2px;\n\n        &:first-child {\n          margin: 0;\n        }\n\n        &:last-child {\n          font-size: 13px;\n        }\n      }\n    }\n\n    &__flx {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      img {\n        width: 25%;\n      }\n    }\n  }\n}\n\n::ng-deep .cn-print {\n  --spc: 50px;\n  --family-7: \"Museo-700\";\n  --family-3: \"Museo-300\";\n  --family-1: \"Museo-100\";\n  max-width: 1000px;\n  margin: 0 auto;\n  padding: 20px;\n  width: 100%;\n  font-family: var(--family-1);\n\n  &-smple {\n    display: block;\n    margin: 0;\n    position: absolute !important;\n    font-size: 8px;\n    background: red;\n    color: #fff;\n    border-radius: 3px;\n    left: 50%;\n    padding-inline: 5px;\n    font-weight: bold;\n    opacity: 0.6;\n  }\n\n  &-ss {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  h3 {\n    font-family: var(--family-7);\n  }\n\n  &__head {\n\n    &--mh {\n      min-height: 600px;\n    }\n\n    .cn-hdr {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      color: #fff;\n      border-radius: 5px 5px 0 0;\n      padding: 20px var(--spc);\n      flex-wrap: wrap;\n\n      &-summary {\n\n        &>h3 {\n          color: #6D6E71 !important;\n          font-size: 50px !important;\n\n          svg {\n            padding-top: 17px;\n            margin-left: -11px;\n          }\n        }\n      }\n\n      &--clarify {\n        background-color: #00AFDA;\n      }\n\n      &--ideate {\n        background-color: #F58A1F;\n      }\n\n      &--implement {\n        background-color: #EE455A;\n      }\n\n      &--develop {\n        background-color: #68BC49;\n      }\n\n      &>h3 {\n        font-size: 30px;\n        color: #fff;\n        margin-block: 0;\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          width: 100%;\n        }\n      }\n\n      p {\n        font-weight: 600;\n        font-family: \"Museo-700\";\n        font-size: 22px;\n        margin-block: 0;\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &__info {\n    display: flex;\n    padding-inline: 50px;\n    justify-content: space-between;\n\n    p {\n      font-family: \"Museo-700\";\n    }\n  }\n\n  &__body {\n    --bdr-size: 1px;\n\n    .cn-item {\n      padding: 10px var(--spc);\n\n      &:last-child {\n        padding-bottom: calc(var(--spc) + 20px);\n      }\n\n      p {\n        font-size: 17px;\n      }\n\n\n      &__txt {\n\n        &:not(:first-child) {\n          margin-top: 10px;\n        }\n\n        &--cl {\n          i {\n            color: $clarify-color;\n          }\n        }\n\n        p:last-child {\n          margin-bottom: 0;\n        }\n      }\n\n      &--cl {\n        background-color: #E2F3F9;\n        padding-bottom: 20px;\n      }\n\n      &--id {\n        background-color: #FFEFE1;\n        padding-bottom: 20px;\n      }\n\n      &--dev {\n        background-color: #ECF5E8;\n        padding-bottom: 20px;\n      }\n\n      &--imple {\n        background-color: #FDE9E5;\n        padding-bottom: 20px;\n      }\n\n      &__top {\n\n        ul {\n          li {\n            .inp-des--txtstyl {\n              font-family: $car-font;\n              color: $body-content-color;\n            }\n          }\n        }\n\n        h3 {\n          font-size: 20px;\n          display: flex;\n          justify-content: space-between;\n          margin-bottom: 4px;\n\n          i {\n            cursor: pointer;\n          }\n        }\n\n        &--cl {\n\n          h3 {\n            font-size: 20px;\n            color: $clarify-color;\n          }\n        }\n\n        &--id {\n          h3 {\n            font-size: 20px;\n            color: $ideate-color;\n          }\n\n          i {\n            color: $ideate-color;\n          }\n        }\n\n        &--dev {\n          h3 {\n            font-size: 20px;\n            color: $develop-color;\n          }\n\n          span {\n            font-family: var(--family-7);\n            color: $develop-color;\n          }\n        }\n\n        &--imple {\n          h3 {\n            font-size: 20px;\n            color: $implement-color;\n          }\n        }\n\n        &--potential {\n          h3 {\n            font-size: 20px;\n            color: #6D6E71;\n          }\n        }\n      }\n\n      &__inp {\n\n\n        .inp {\n\n          &-des {\n            border: var(--bdr-size) solid $clarify-color;\n\n            &--txtstyl {\n              font-family: $car-font;\n              color: $body-content-color;\n            }\n\n            &-id {\n              border: var(--bdr-size) solid $ideate-color;\n\n              .tabular {\n                counter-reset: section;\n\n                &-flx {\n                  display: flex;\n\n                  &>div {\n\n                    ol {\n                      display: block;\n\n                      li {\n                        width: 100%;\n\n                        &:nth-of-type(2n) {\n                          border-left: 0;\n                        }\n\n                        &:nth-last-of-type(2) {\n                          border-bottom: var(--bdr-size) dashed $ideate-color;\n                        }\n                      }\n\n                      // &.list {\n                      //     counter-reset: section 15;\n\n                      //     &::before {\n                      //         counter-increment: section;\n                      //         content: \"\" counter(section) \". \";\n                      //     }\n                      // }\n                    }\n                  }\n                }\n\n                ol {\n                  list-style: none;\n                  display: flex;\n                  flex-wrap: wrap;\n\n                  li {\n                    color: $ideate-color;\n                    width: 50%;\n\n                    &::before {\n                      counter-increment: section;\n                      content: \"\" counter(section) \". \";\n                    }\n\n                    &:nth-of-type(2n) {\n                      border-left: var(--bdr-size) solid $ideate-color;\n                    }\n\n                    &:nth-last-of-type(2) {\n                      border-bottom: 0;\n                    }\n                  }\n                }\n\n                &>div {\n                  width: 50%;\n\n                  &:first-child {\n                    border-right: var(--bdr-size) solid $ideate-color;\n                  }\n                }\n              }\n            }\n\n\n            &-dev {\n              border: var(--bdr-size) solid $develop-color;\n\n              table {\n                color: $develop-color;\n\n                th,\n                td {\n                  border-bottom: 1px dashed $develop-color;\n\n                  &.bb-0 {\n                    border-bottom: 0;\n                  }\n\n                }\n\n                tr:last-child {\n\n                  th,\n                  td {\n                    border-bottom: 0;\n                  }\n                }\n\n\n\n                thead {\n                  tr {\n\n                    th {\n                      border-right: 1px solid $develop-color;\n                      width: 290px;\n                      padding: 8px 10px;\n\n                      &:last-child {\n                        border-right: 0;\n                      }\n\n                      span {\n                        height: 25px;\n                        width: 25px;\n                        background: $develop-color;\n                        display: inline-block;\n                        border-radius: 50%;\n                        text-align: center;\n                        font-size: 11px;\n                        color: #fff;\n                        padding: 5px 8px;\n                      }\n\n                      p {\n                        font-size: 12px;\n                        font-weight: 400;\n                        flex: 1;\n                        padding-left: 10px;\n                        margin-bottom: 0;\n\n                        strong {\n                          font-family: var(--family-7);\n                          font-size: 14px;\n                        }\n                      }\n\n                      .ev-th {\n                        display: flex;\n                        flex-wrap: wrap;\n                      }\n                    }\n                  }\n                }\n\n                tbody {\n\n                  tr {\n\n                    td {\n                      border-right: 1px solid $develop-color;\n                      padding: 8px 10px;\n                      vertical-align: text-top;\n\n                      &.opp {\n                        font-weight: 700;\n                        border-top: var(--bdr-size) solid $develop-color;\n                        border-bottom: var(--bdr-size) solid $develop-color;\n\n                        span {\n                          height: 25px;\n                          width: 25px;\n                          background: $develop-color;\n                          display: inline-block;\n                          border-radius: 50%;\n                          text-align: center;\n                          font-size: 11px;\n                          color: #fff;\n                          padding: 5px 8px;\n                        }\n\n                        .ev-td {\n                          display: flex;\n                          flex-wrap: wrap;\n\n                          p {\n                            font-size: 12px;\n                            font-weight: 400;\n                            flex: 1;\n                            padding-left: 10px;\n\n                            strong {\n                              font-family: var(--family-7);\n                              font-size: 14px;\n                            }\n                          }\n                        }\n\n\n                      }\n\n                      &:last-child {\n                        border-right: 0;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n\n            &-imple {\n              border: var(--bdr-size) solid $implement-color;\n\n              table {\n                width: 100%;\n                color: $implement-color;\n\n                tr {\n\n                  &.imple-clr {\n                    background-color: $implement-color;\n                    color: #fff;\n                    font-weight: 700;\n                    font-size: 12px;\n\n                    td {\n\n                      &:not(:last-child) {\n                        border-right: 1px dashed #fff;\n                      }\n                    }\n                  }\n\n                  th {\n                    padding: 8px 10px;\n                    border-right: 1px dashed $implement-color;\n                    font-family: var(--family-1);\n                    font-weight: normal;\n                    text-transform: uppercase;\n\n                    &.dark-th {\n                      color: $color-neutral-dark;\n                      font-family: var(--family-1);\n                      padding-left: 0;\n                      font-weight: normal;\n                      text-transform: none;\n                    }\n\n                    &:first-child {\n                      width: 72%;\n                    }\n\n                    &:last-child {\n                      border-right: none;\n                    }\n                  }\n\n                  td {\n                    border-right: 1px dashed $implement-color;\n                    border-bottom: 1px dashed $implement-color;\n                    padding: 8px 10px;\n                    font-size: 13px;\n                    letter-spacing: 1px;\n\n                    &:first-child {\n                      width: 72%;\n                    }\n\n                    &:last-child {\n                      border-right: none;\n                    }\n                  }\n\n                  &:last-child {\n\n                    td {\n                      border-bottom: 0;\n                    }\n                  }\n                }\n              }\n            }\n\n            &-summary {\n              border: none;\n\n              thead {\n\n                tr {\n                  border-inline: 0;\n\n                  th {\n                    border: 0;\n                  }\n                }\n              }\n\n              tbody {\n                tr {\n                  border-inline: var(--bdr-size) solid $implement-color;\n                  border-bottom: var(--bdr-size) solid $implement-color;\n\n                  &:first-child {\n                    border-top: var(--bdr-size) solid $implement-color;\n                  }\n\n                  &:not(:last-child) {\n                    border-bottom: var(--bdr-size) dashed $implement-color;\n                  }\n\n                }\n              }\n\n            }\n\n            &-potential {\n              border: var(--bdr-size) solid #6D6E71;\n            }\n\n            ol {\n              list-style-type: none;\n              padding: 0;\n              margin: 0;\n\n              li {\n                border-bottom: var(--bdr-size) dashed $clarify-color;\n                min-height: 32px;\n                background-color: #fff;\n                min-height: 32px;\n                padding: 8px 10px;\n                margin: 0;\n                color: $clarify-color;\n                font-family: var(--family-7);\n\n\n                &.id {\n                  border-bottom: var(--bdr-size) dashed $ideate-color;\n\n                }\n\n                &.dev {\n                  border-bottom: var(--bdr-size) dashed $develop-color;\n                  color: $develop-color;\n                }\n\n                &.imple {\n                  border-bottom: var(--bdr-size) dashed $implement-color;\n                  color: $implement-color;\n                }\n\n                &.potential {\n                  border-bottom: var(--bdr-size) dashed #6D6E71;\n                  color: #6D6E71;\n                }\n\n                &:last-child {\n                  border-bottom: 0;\n                }\n              }\n            }\n\n\n            &__data {\n              min-height: 220px;\n              border: 0;\n\n              .inp-des--txtstyl {\n                padding-left: 40px;\n              }\n\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &-nav {\n\n    ul {\n\n      li {\n\n        @media (min-width: 769px) and (max-width: 991px),\n        (max-width: 640px) {\n\n          margin: 0 !important;\n          width: 100%;\n        }\n      }\n\n      @media (min-width: 769px) and (max-width: 991px),\n      (max-width: 640px) {\n        gap: 6px;\n      }\n    }\n\n\n  }\n}\n\n.page-heading {\n  display: flex;\n\n  &__inner {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin: 0 -10px;\n    width: 100%;\n\n    a {\n      font-family: 'Open Sans', sans-serif;\n    }\n\n    .page-heading__col {\n      padding: 0 10px;\n\n      &--pd {\n        padding: 0 25px;\n      }\n\n      &--left {\n\n        @media #{$mq-pc} {\n          width: 100%;\n        }\n      }\n\n      &.page-heading__col--right {\n        margin-left: auto;\n\n        @media #{$mq-pc} {\n          width: 100%;\n        }\n\n        &>ul {\n          padding: 0;\n          margin: 0;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n\n          &>li {\n            list-style: none;\n            position: relative;\n            margin-top: 7px;\n            margin-bottom: 7px;\n\n            @media #{$mq-pc} {\n              margin-top: 0;\n              margin-bottom: 10px;\n            }\n\n            &:not(:last-child) {\n              margin-right: 15px;\n\n              @media #{$mq-pc} {\n                margin-right: 10px;\n              }\n            }\n\n            &>a {\n              font-size: 16px;\n              color: #676a6a;\n              font-weight: 700;\n              background-color: #fff;\n              border: 1px solid #ededed;\n              border-radius: 6px;\n              overflow: hidden;\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -ms-flex-wrap: wrap;\n              flex-wrap: wrap;\n              -webkit-transition: all ease 0.3s;\n              -o-transition: all ease 0.3s;\n              transition: all ease 0.3s;\n\n              @media #{$mq-pc} {\n                font-size: 14px;\n              }\n\n              @media #{$mq-sm} {\n                font-size: 13px;\n              }\n\n              .page-heading__icon {\n                padding: 11px 14px;\n                border-right: 1px solid #ededed;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n\n                @media #{$mq-pc} {\n                  padding: 10px 12px;\n                }\n\n                @media #{$mq-md} {\n                  padding: 9px 10px;\n                }\n\n              }\n\n              .page-heading__text {\n                padding: 11px 14px;\n\n                @media #{$mq-pc} {\n                  padding: 10px 12px;\n                }\n\n                @media #{$mq-md} {\n                  padding: 9px 10px;\n                }\n              }\n\n              &:hover {\n                border: 1px solid #CFDBE2;\n              }\n            }\n\n            &:hover>ul {\n              display: block;\n            }\n\n            ul {\n              margin: 0;\n              padding: 0;\n              display: none;\n              position: absolute;\n              top: calc(100% - 1px);\n              right: 0;\n              width: 144px;\n              border: 1px solid #dcdcdc;\n              border-radius: 3px;\n              background-color: #fff;\n\n              li {\n                list-style: none;\n\n                &+li {\n                  border-top: 1px solid #dcdcdc;\n                }\n\n                a {\n                  color: #696969;\n                  text-align: center;\n                  padding: 8px 20px;\n                  font-size: 13px;\n                  display: block;\n                  -webkit-transition: all ease 0.3s;\n                  -o-transition: all ease 0.3s;\n                  transition: all ease 0.3s;\n\n                  &:hover {\n                    background-color: #f9f9f9;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep footer {\n  .footer {\n    position: relative;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
